const options = {
  5: "bg-green-700/5",
  10: "bg-green-700/10",
  25: "bg-green-700/25",
  50: "bg-green-700/50",
  75: "bg-green-700/75",
  90: "bg-green-700/90",
  100: "bg-green-700",
};

const from = {
  5: "from-green-700/5",
  10: "from-green-700/10",
  25: "from-green-700/25",
  50: "from-green-700/50",
  75: "from-green-700/75",
  90: "from-green-700/90",
  100: "from-green-700",
};

export default function getBackgroundGreen700(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
